import { FC, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Download } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { Page, PageTitle } from '../../../components';
import { WarrantyMessagesList } from './warranty-messages-list';
import { exportWarrantyMessages } from '../../../fetch';
import { downloadFile, getDownloadFileName } from '../../../helpers';

export const WarrantyMessages: FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [currentFilters, setCurrentFilters] = useState<{
    searchText?: string;
    startDate?: string;
    endDate?: string;
    jobStatus?: string;
  }>({});

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const response = await exportWarrantyMessages(currentFilters);
      downloadFile(response.data, getDownloadFileName(response));
    } catch (error) {
      enqueueSnackbar(error?.Detail ?? 'Unable to download file, please try again.', {
        variant: 'error'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Page title="Warranty Messages" showSideBar={false} sideBarLinks={[]}>
      <PageTitle
        title="Warranty Messages"
        additionalHeaderContent={
          <LoadingButton
            id="export-warranty-messages"
            type="button"
            color="primary"
            variant="contained"
            loading={isExporting}
            startIcon={<Download />}
            onClick={handleExport}
          >
            Export CSV
          </LoadingButton>
        }
      />
      <WarrantyMessagesList onFiltersChange={setCurrentFilters} />
    </Page>
  );
};
